var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.6666C17.5 15.2153 16.1087 13.9806 14.1667 13.523M12.5 16.6667C12.5 14.8257 10.2614 13.3334 7.5 13.3334C4.73858 13.3334 2.5 14.8257 2.5 16.6667M12.5 10.8334C14.3409 10.8334 15.8333 9.34097 15.8333 7.50002C15.8333 5.65907 14.3409 4.16669 12.5 4.16669M7.5 10.8334C5.65905 10.8334 4.16667 9.34097 4.16667 7.50002C4.16667 5.65907 5.65905 4.16669 7.5 4.16669C9.34095 4.16669 10.8333 5.65907 10.8333 7.50002C10.8333 9.34097 9.34095 10.8334 7.5 10.8334Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsersIcon);
export default __webpack_public_path__ + "static/media/addUsersIcon.760a3ad44d23ae013abe66f140d73d90.svg";
export { ForwardRef as ReactComponent };